import { IUser } from '~/../backend/types/user';
import { axiosInstance } from './config';

export const userAPIService = {
  getAccount: async () => {
    return axiosInstance.get<IUser>('/user');
  },
  joinMemberShip: async (email: string) => {
    return axiosInstance.post<IUser>('/user/membership', { email });
  },
  leaveMemberShip: async () => {
    return axiosInstance.delete<IUser>('/user/membership');
  },
  updateEmailMemberShip: async (email: string) => {
    return axiosInstance.put<IUser>('/user/membership', { email });
  },
  resendEmailVerification: async (email: string) => {
    return axiosInstance.post<IUser>('/user/verification', { email });
  },
  emailVerification: async (email: string, code: string) => {
    return axiosInstance.post<IUser>('/verifications', { email, code });
  },
};
